import React from 'react';
export function Footer() {
  return <footer className="bg-[#2D2926] text-white py-12 px-4" data-id="element-52">
      <div className="max-w-6xl mx-auto" data-id="element-53">
        <div className="text-center" data-id="element-54">
          <p className="text-2xl font-bold font-['Playfair_Display'] mb-4" data-id="element-55">
            Menopausia en Calma
          </p>

          <div className="flex items-center justify-center gap-6 mb-6 text-sm text-white/70" data-id="element-56">
            <a href="#" className="hover:text-white transition-colors" data-id="element-57">
              Política de Privacidad
            </a>
            <span className="text-white/30" data-id="element-58">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-59">
              Términos y Condiciones
            </a>
            <span className="text-white/30" data-id="element-60">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-61">
              Contacto
            </a>
          </div>

          <p className="text-sm text-white/50" data-id="element-62">
            © 2025 Menopausia en Calma. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}